import React from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import { useLoaderData } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import {
    HeroSection,
    TextSection,
    VideoSection,
    VideoBackground,
} from '../styles/home.styles';
import AboutMe from '../components/AboutMe';
import SkillsShowcase from '../components/SkillsShowcase';
import AwardsShowcase from '../components/AwardsShowcase';

function Home() {
    const { videos } = useLoaderData();
    const theme = useTheme();

    const scrollToAboutSection = () => {
        const aboutSection = document.getElementById('about');
        if (aboutSection) {
            aboutSection.scrollIntoView({ 
                behavior: 'smooth',
                block: 'start'
            });
        }
    };

    return (
        <>
            <HeroSection>
                <TextSection>
                    <Container>
                        <Box sx={{ maxWidth: '90%', margin: '0 auto', textAlign: 'center' }}>
                            <Typography
                                variant="h2" 
                                gutterBottom 
                                sx={{ 
                                    fontWeight: 800,
                                    fontSize: { xs: '2.5rem', md: '3.75rem' },
                                    marginBottom: 4,
                                    lineHeight: 1.2,
                                    textShadow: theme.palette.mode === 'dark' 
                                        ? '3px 3px 6px rgba(0,0,0,0.5)'
                                        : '2px 2px 4px rgba(0,0,0,0.3)',
                                    letterSpacing: '-0.02em',
                                    color: theme.palette.text.primary,
                                }}
                            >
                                Naga Venkata Satish, Divvi
                            </Typography>
                            <Typography 
                                variant="body1" 
                                sx={{ 
                                    fontSize: '1.25rem',
                                    marginBottom: 3,
                                    opacity: 1,
                                    textShadow: theme.palette.mode === 'dark'
                                        ? '1px 1px 3px rgba(0,0,0,0.3)'
                                        : '1px 1px 2px rgba(0,0,0,0.2)',
                                    fontWeight: 500,
                                    color: theme.palette.text.secondary,
                                }}
                            >
                                Senior Software Development Engineer
                            </Typography>
                            <Button
                                align="center"
                                variant="contained" 
                                color="primary" 
                                size="large"
                                onClick={scrollToAboutSection}
                                sx={{
                                    backgroundColor: theme.palette.primary.main,
                                    '&:hover': {
                                        backgroundColor: theme.palette.primary.dark,
                                    }
                                }}
                            >
                                About Me
                            </Button>
                        </Box>
                    </Container>
                </TextSection>

                <VideoSection>
                    <VideoBackground>
                        <video
                            autoPlay
                            muted
                            loop
                            playsInline
                        >
                            <source 
                                src={videos.homePageVideo} 
                                type="video/mp4" 
                            />
                            Your browser does not support the video tag.
                        </video>
                    </VideoBackground>
                </VideoSection>
            </HeroSection>

            <AboutMe />
            <SkillsShowcase />
            <AwardsShowcase />
        </>
    );
}

export default Home;
